module.exports = __webpack_public_path__ + "static/img/2.02a7ed4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/zh/2.png
// module id = Bxpr
// module chunks = 0